export default __webpack_public_path__ + "app/images/theme-images/light/remove-upload-file-btn/icon-20-close-fill@2x.webp";